exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#components-pagination-demo-mini .ant-pagination[data-v-259ce93c]:not(:last-child){margin-bottom:24px}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Developer/maeriminterfood/pos_mis-master/src/views/role_list.vue"],"names":[],"mappings":"AACA,mFACE,kBAAoB,CACrB","file":"role_list.vue","sourcesContent":["\n#components-pagination-demo-mini .ant-pagination[data-v-259ce93c]:not(:last-child) {\n  margin-bottom: 24px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-259ce93c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/role_list.vue
// module id = 1255
// module chunks = 27